import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { CreatorsAnchors } from '../../../../store/ducks/anchors';

import axios from 'axios';
import api from '../../../../services/api';
import { getPermissions } from '../../../../services/auth';
import { dataAtualFormatada, toDecimal } from '../../../../utils/functions';
import { RECEBE_EMAIL } from '../../../../utils/constantsAnchors';

import { useHistory } from 'react-router';

import Render from './EditRender';

function Edit({ id }) {
  const history = useHistory();
  const dispatch = useDispatch();

  const [inputs, setInputs] = useState({});
  const [destinoOpcoes, setDestinoOpcoes] = useState([]);
  const [getLoading, setLoading] = useState(true);
  const [getErros, setErros] = useState([]);

  const [getEstados, setEstados] = useState([]);
  const [getMunicipios, setMunicipios] = useState([]);
  const [inputsBlocked, setInputsBlocked] = useState([]);

  const [getStatusAncorasContatos, setStatusAncorasContatos] = useState();
  const [getAncorasContatos, setAncorasContatos] = useState([]);
  const [getAncorasLoadingContatos, setAncorasLoadingContatos] = useState(true);

  const [getStatusAncorasLojas, setStatusAncorasLojas] = useState();
  const [getAncorasLojas, setAncorasLojas] = useState([]);
  const [getAncorasLoadingLojas, setAncorasLoadingLojas] = useState(true);

  const [getStatusAncorasTaxasFaixas, setStatusAncorasTaxasFaixas] = useState();
  const [getAncorasTaxasFaixas, setAncorasTaxasFaixas] = useState([]);
  const [getAncorasLoadingTaxasFaixas, setAncorasLoadingTaxasFaixas] = useState(true);

  const [getLayoutsEmailsAncoras, setLayoutsEmailsAncoras] = useState([]);
  const [getLayoutsEmailsInteresses, setLayoutsEmailsInteresses] = useState([]);
  const [getLayoutsEmailsAntecipacoes, setLayoutsEmailsAntecipacoes] = useState([]);
  const [getLayoutsEmailsAntecipacoesAprovadas, setLayoutsEmailsAntecipacoesAprovadas] = useState(
    [],
  );
  const [getLayoutsEmailsAntecipacoesReprovadas, setLayoutsEmailsAntecipacoesReprovadas] = useState(
    [],
  );
  const [getLayoutsEmailsAntecipacoesVencidas, setLayoutsEmailsAntecipacoesVencidas] = useState([]);
  const [getLayoutsArquivoTitulosImportação, setLayotsArquivoTitulosImportação] = useState([]);
  const [getLayoutsArquivoTituloExportação, setLayotsArquivoTitulosExportação] = useState([]);
  const [getLayoutsEmailsFechamentosMeses, setLayoutsEmailsFechamentosMeses] = useState([]);

  const handleInputChange = (event, value) => {
    event.persist();
    setInputs((inputs) => ({ ...inputs, [event.target.name]: value || event.target.value }));
  };

  const getInfoForForm = async () => {
    try {
      const findAncorasContato = await api.get(`Ancoras/ConsultarId?id=${id}`);
      const searchStates = await api.get('Estados/Consultar?status=Ativo');
      const findLayoutsEmailsAncoras = await api.get('LayoutsEmailsAncoras/Consultar?status=Ativo');
      const findLayoutsEmailsInteresses = await api.get(
        'LayoutsEmailsInteresses/Consultar?status=Ativo',
      );
      const findLayoutsEmailsAntecipacoes = await api.get(
        'LayoutsEmailsFornecedores/Consultar?status=Ativo',
      );
      const findLayoutsEmailsAntecipacoesAprovadas = await api.get(
        'LayoutsEmailsAntecipacoesAprovadas/Consultar?status=Ativo',
      );
      const findLayoutsEmailsAntecipacoesReprovadas = await api.get(
        'LayoutsEmailsAntecipacoesReprovadas/Consultar?status=Ativo',
      );
      const findLayoutsEmailsAntecipacoesVencidas = await api.get(
        'LayoutsEmailsAntecipacoesVencidas/Consultar?status=Ativo',
      );
      const findLayoutsArquivoTitulosExportação = await api.get(
        'LayoutsArquivosExportacoes/Consultar?status=Ativo',
      );
      const findLayoutsArquivoTitulosImportação = await api.get(
        'LayoutsArquivosImportacoes/Consultar?status=Ativo',
      );
      const findLayoutsEmailsFechamentosMeses = await api.get(
        'LayoutsEmailsFechamentosMeses/Consultar?status=Ativo',
      );
      const destinos = await api.get('DestinosPagamentos/Consultar?status=Ativo')

      setEstados(searchStates.data.resposta);
      setLayoutsEmailsAncoras(findLayoutsEmailsAncoras.data.resposta);
      setLayoutsEmailsInteresses(findLayoutsEmailsInteresses.data.resposta);
      setLayoutsEmailsAntecipacoes(findLayoutsEmailsAntecipacoes.data.resposta);
      setLayoutsEmailsAntecipacoesAprovadas(findLayoutsEmailsAntecipacoesAprovadas.data.resposta);
      setLayoutsEmailsAntecipacoesReprovadas(findLayoutsEmailsAntecipacoesReprovadas.data.resposta);
      setLayoutsEmailsAntecipacoesVencidas(findLayoutsEmailsAntecipacoesVencidas.data.resposta);
      setLayotsArquivoTitulosImportação(findLayoutsArquivoTitulosImportação.data.resposta);
      setLayotsArquivoTitulosExportação(findLayoutsArquivoTitulosExportação.data.resposta);
      setLayoutsEmailsFechamentosMeses(findLayoutsEmailsFechamentosMeses.data.resposta);
      setDestinoOpcoes(destinos.data.resposta)

      const responseForInputs = findAncorasContato.data.resposta;

      dispatch(CreatorsAnchors.changeLastAnchor(responseForInputs.nomeFantasia));
      let dddVazio = '';

      if (responseForInputs.telefoneComercialDDD !== '') {
        dddVazio = `(${responseForInputs.telefoneComercialDDD}) `;
      }

      setInputs({
        ...responseForInputs,
        telefoneComercialNumero: responseForInputs.telefoneComercialNumero && `${dddVazio}${responseForInputs.telefoneComercialNumero}`,
      });
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.');
      }
    }
    setLoading(false);
  };

  const getAllMunicipios = async () => {
    try {
      const searchCities = await api.get(
        `Municipios/ConsultarEstadoId?id=${inputs.estadoId}&status=Ativo`,
      );
      setMunicipios(searchCities.data.resposta);
      setInputs({ ...inputs, municipioId: inputs.municipioId });
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.');
      }
    }
  };

  useEffect(() => {
    if (inputs.estadoId) {
      getAllMunicipios();
    }
  }, [inputs.estadoId]);

  useEffect(() => {
    const permissions = getPermissions({ moduloId: 711, permissao: 'Consultar' });

    if (permissions) {
      getInfoForForm();
    } else {
      history.push('/app');
    }
  }, []);

  const handleSubmit = async (event) => {
    if (event) {
      event.preventDefault();
      setLoading(true);
      try {
        console.log('📞 DEBUG TELEFONE ANTES DE ENVIAR:', {
          original: inputs.telefoneComercialNumero,
          ddd: inputs.telefoneComercialNumero && inputs.telefoneComercialNumero.trim() !== '' ? dddTel(inputs.telefoneComercialNumero, 'ddd') : '',
          numero: inputs.telefoneComercialNumero && inputs.telefoneComercialNumero.trim() !== '' ? dddTel(inputs.telefoneComercialNumero) : ''
        });
        
        const response = await api.put('Ancoras', {
          ...inputs,
          custoCdi: toDecimal(inputs.custoCdi),
          dataAberturaEmpresa:
            inputs.dataAberturaEmpresa && dataAtualFormatada(inputs.dataAberturaEmpresa),
          emailPort: inputs.emailPort && parseInt(inputs.emailPort),
          estadoId: inputs.estadoId && parseInt(inputs.estadoId),
          layoutEmailAncoraId: inputs.layoutEmailAncoraId && parseInt(inputs.layoutEmailAncoraId),
          layoutEmailAntecipacaoId:
            inputs.layoutEmailAntecipacaoId && parseInt(inputs.layoutEmailAntecipacaoId),
          layoutEmailInteresseId:
            inputs.layoutEmailInteresseId && parseInt(inputs.layoutEmailInteresseId),
          minimoDiasParaPagamento:
            inputs.minimoDiasParaPagamento && parseInt(inputs.minimoDiasParaPagamento),
          municipioId: inputs.municipioId && parseInt(inputs.municipioId),
          numero: inputs.numero && parseInt(inputs.numero),
          sistemaAncoraId: inputs.sistemaAncoraId && parseInt(inputs.sistemaAncoraId),
          telefoneComercialNumero:
            inputs.telefoneComercialNumero && inputs.telefoneComercialNumero.trim() !== '' ? dddTel(inputs.telefoneComercialNumero) : '',
          telefoneComercialDDD: inputs.telefoneComercialNumero && inputs.telefoneComercialNumero.trim() !== '' ? dddTel(inputs.telefoneComercialNumero, 'ddd') : '',
          horaLimiteAceitePropostaSegunda: inputs.horaLimiteAceitePropostaSegunda,
          horaLimiteAceitePropostaTerca: inputs.horaLimiteAceitePropostaTerca,
          horaLimiteAceitePropostaQuarta: inputs.horaLimiteAceitePropostaQuarta,
          horaLimiteAceitePropostaQuinta: inputs.horaLimiteAceitePropostaQuinta,
          horaLimiteAceitePropostaSexta: inputs.horaLimiteAceitePropostaSexta,
          obrigaDigitoAgencia: inputs.obrigaDigitoAgencia,
          erp: inputs.erp,
          tiposDadosBancarios: inputs.tiposDadosBancarios,
          tipoResumoDiario: inputs.tipoResumoDiario,
          custoCdiAtualizacaoAutomatica: inputs.custoCdiAtualizacaoAutomatica,
          vencimentoTituloEmDMais: Number(inputs.vencimentoTituloEmDMais),
          enviarEmailsDeInteresseAposProcessarArquivo: inputs.enviarEmailsDeInteresseAposProcessarArquivo,
          enviarWhatsAppAposProcessarArquivo: inputs.enviarWhatsAppAposProcessarArquivo,
          envioAutomaticoPropostasAprovadas: inputs.envioAutomaticoPropostasAprovadas,
          controlaCorporate: inputs.controlaCorporate
        });
        if (response.data.status !== 'Inconsistencia') {
          toast.success('Rede alterada com sucesso!');
        } else {
          if (response.data.resposta[0].key) {
            const errosArray = [];

            response.data.resposta.map((resposta) => {
              errosArray.push(resposta.key);

              toast.error(resposta.key + ' - ' + resposta.message);
              return null;
            });

            setErros(errosArray);
          } else {
            toast.error('Não foi possível alterar a rede!');
          }
        }
      } catch (err) {
        if (err.response.data && err.response.data.resposta[0]) {
          toast.error(err.response.data.resposta[0].message);
        } else {
          toast.error('Detectamos um problema interno! tente novamente em instantes.');
        }
      }
      setLoading(false);
    }
  };

  async function findAllAncorasContatos() {
    setAncorasLoadingContatos(true);
    try {
      const response = await api.get(
        `AncorasContatos/ConsultarAncoraId?id=${id}${
          getStatusAncorasContatos ? `&status=${getStatusAncorasContatos}` : ''
        }`,
      );

      const newStateContatos = response.data.resposta.length
        ? response.data.resposta.map((contato) => ({
            ...contato,
            telefone1:
              contato.telefone1 &&
              (contato.ddd1 ? `(${contato.ddd1}) ${contato.telefone1}` : `${contato.telefone1}`),
            telefone2:
              contato.telefone2 &&
              (contato.ddd2 ? `(${contato.ddd2}) ${contato.telefone2}` : `${contato.telefone2}`),
            receberEmailAntecipacoesAprovadas:
              contato.receberEmailAntecipacoesAprovadas === 'RecebePrincipal'
                ? RECEBE_EMAIL.RecebePrincipal
                : contato.receberEmailAntecipacoesAprovadas === 'NaoRecebe'
                ? RECEBE_EMAIL.NaoRecebe
                : RECEBE_EMAIL.RecebeCopia,
            receberEmailFechamentoMes:
              contato.receberEmailFechamentoMes === 'RecebePrincipal'
                ? RECEBE_EMAIL.RecebePrincipal
                : contato.receberEmailFechamentoMes === 'NaoRecebe'
                ? RECEBE_EMAIL.NaoRecebe
                : RECEBE_EMAIL.RecebeCopia,
          }))
        : [];
      setAncorasContatos(newStateContatos);
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.');
      }
    }
    setAncorasLoadingContatos(false);
  }

  async function findAllAncorasLojas() {
    setAncorasLoadingLojas(true);
    try {
      const response = await api.get(
        `AncorasLojas/ConsultarAncoraId?id=${id}${
          getStatusAncorasLojas ? `&status=${getStatusAncorasLojas}` : ''
        }`,
      );
      setAncorasLojas(response.data.resposta);
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.');
      }
    }
    setAncorasLoadingLojas(false);
  }

  async function findAllAncorasTaxasFaixas() {
    setAncorasLoadingTaxasFaixas(true);
    try {
      const response = await api.get(
        `AncorasTaxasFaixas/ConsultarAncoraId?id=${id}${
          getStatusAncorasTaxasFaixas ? `&status=${getStatusAncorasTaxasFaixas}` : ''
        }`,
      );
      setAncorasTaxasFaixas(response.data.resposta);
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.');
      }
    }
    setAncorasLoadingTaxasFaixas(false);
  }

  const findCep = async (cep) => {
    cep = cep.replace('-', '').replace('.', '');
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json`);
      const { logradouro, bairro, ibge } = response.data;

      if (logradouro.length) {
        setInputsBlocked((inputsBlocked) => [...inputsBlocked, 'logradouro']);
      }
      if (bairro.length) {
        setInputsBlocked((inputsBlocked) => [...inputsBlocked, 'bairro']);
      }

      if (ibge.length) {
        setInputsBlocked((inputsBlocked) => [...inputsBlocked, 'estado', 'municipio']);
        const responseMunicipio = await api.get(`Municipios/ConsultarIBGEId?id=${ibge}`);
        const { estadoId, municipioId } = responseMunicipio.data.resposta[0];
        setInputs({ ...inputs, logradouro, bairro, estadoId, municipioId });

        const listFields = ['Cep', 'Logradouro', 'Bairro', 'EstadoId', 'MunicipioId'];

        setErros(
          getErros.filter(function (item) {
            return !listFields.includes(item);
          }),
        );
      } else {
        setInputs({ ...inputs, logradouro, bairro });
      }
    } catch (err) {
      setInputsBlocked([]);
    }
  };

  return (
    <Render
      ancoraId={id}
      inputs={inputs}
      getLoading={getLoading}
      handleInputChange={handleInputChange}
      onSubmit={handleSubmit}
      findAllAncorasContatos={findAllAncorasContatos}
      getAncorasContatos={getAncorasContatos}
      getAncorasLoadingContatos={getAncorasLoadingContatos}
      getStatusAncorasContatos={getStatusAncorasContatos}
      setStatusAncorasContatos={setStatusAncorasContatos}
      findAllAncorasLojas={findAllAncorasLojas}
      getAncorasLojas={getAncorasLojas}
      getAncorasLoadingLojas={getAncorasLoadingLojas}
      getStatusAncorasLojas={getStatusAncorasLojas}
      setStatusAncorasLojas={setStatusAncorasLojas}
      findAllAncorasTaxasFaixas={findAllAncorasTaxasFaixas}
      getAncorasTaxasFaixas={getAncorasTaxasFaixas}
      getAncorasLoadingTaxasFaixas={getAncorasLoadingTaxasFaixas}
      getStatusAncorasTaxasFaixas={getStatusAncorasTaxasFaixas}
      setStatusAncorasTaxasFaixas={setStatusAncorasTaxasFaixas}
      getErros={getErros}
      setErros={setErros}
      findCep={findCep}
      inputsBlocked={inputsBlocked}
      getEstados={getEstados}
      getMunicipios={getMunicipios}
      getLayoutsEmailsAncoras={getLayoutsEmailsAncoras}
      getLayoutsEmailsInteresses={getLayoutsEmailsInteresses}
      getLayoutsEmailsAntecipacoes={getLayoutsEmailsAntecipacoes}
      getLayoutsEmailsAntecipacoesAprovadas={getLayoutsEmailsAntecipacoesAprovadas}
      getLayoutsEmailsAntecipacoesReprovadas={getLayoutsEmailsAntecipacoesReprovadas}
      getLayoutsEmailsAntecipacoesVencidas={getLayoutsEmailsAntecipacoesVencidas}
      getLayoutsArquivoTitulosImportação={getLayoutsArquivoTitulosImportação}
      getLayoutsArquivoTituloExportação={getLayoutsArquivoTituloExportação}
      getLayoutsEmailsFechamentosMeses={getLayoutsEmailsFechamentosMeses}
      destinoOpcoes={destinoOpcoes}
    />
  );
}

export default Edit;
